import Feature from "ol/Feature";
import { Polygon } from "ol/geom";
import { Fill, Stroke, Style } from "ol/style";

export const writeLimits = (data = {}) => {
  const {
    active,
    area_layer,
    allMaps,
    terId,
    selected = false,
    satColor,
  } = data;

  area_layer.getSource().clear();
  let polyCenter = null;
  let isEmpty = true;
  allMaps
    .filter((e) => (e.ID === Number(terId) || active) && e.LIMITES.length > 0)
    .forEach((o) => {
      const geometry = new Polygon([
        new Polygon([o.LIMITES])
          .transform("EPSG:4326", "EPSG:3857")
          .getCoordinates()[0],
      ]);

      let poly = new Feature({
        group: `boundary${o.ID === Number(terId) ? " selected" : ""}`,
        id: o.ID,
        name: o.NOM,
        color: o.LCOLOR,
        geometry,
      });

      if (o.ID === Number(terId)) {
        polyCenter = geometry;
        isEmpty = false;
      }

      // if (o.LCOLOR || o.ID !== Number(terId)) {
      let rgb =
        selected && selected === o.ID
          ? satColor
            ? [33, 255, 0]
            : [255, 42, 0]
          : o.ID !== Number(terId)
          ? satColor
            ? [255, 255, 255]
            : [53, 53, 53]
          : satColor
          ? [255, 255, 0]
          : [0, 0, 255];
      if (rgb.length === 3) {
        let _style = new Style({
          fill: new Fill({
            color: `rgba(${rgb.join(",")}, 0.05)`,
            weight: 1,
          }),
          stroke: new Stroke({
            color: `rgba(${rgb.join(",")}, 0.5)`,
            width: 3,
          }),
        });
        poly.setStyle(_style);
      }
      // }
      area_layer.getSource().addFeature(poly);
      return true;
    });
  return {
    data: polyCenter ?? (terId === "all" ? area_layer.getSource() : false),
    isEmpty,
  };
};
